import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Card from "@components/ui-components/card";
import Charts from "@components/charts";
import Flex from "@components/ui-components/flex";
import StatsFormatter from "@components/formatters/stats-formatter";
import useRetentionReport from "./use-retention-report";
import { useTranslation } from "react-i18next";
import { LAST_7_DAYS_DATE } from "@src/utility/constants";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import DateRangePicker from "@src/@core/components/fields/date-picker/range-picker";
import { Fragment } from "react";
import { LoaderOverlay } from "@src/@core/components/spinner";

const RetentionReport = () => {
    const { data, getRetentionReport, loading } = useRetentionReport();
    const { t } = useTranslation();

    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getRetentionReport,
        defaultValues  : LAST_7_DAYS_DATE,
        defaultHandling: true
    });

    const widgetSections = [
        {
            id    : "averageNetRetentionRate",
            label : "Average Net Retention Rate",
            suffix: "%",
            value : data.widgets.averageNetRetentionRate
        },
        {
            id          : "netTotal",
            label       : "Net Total",
            prefix      : "$",
            value       : data.widgets.netTotal,
            nextOperator: "="
        },
        {
            id          : "expansion",
            label       : "Expansion",
            prefix      : "$",
            value       : data.widgets.expansion,
            nextOperator: "-"
        },
        {
            id          : "contractions",
            label       : "Contractions",
            prefix      : "$",
            value       : data.widgets.contractions,
            nextOperator: "-"
        },
        {
            id    : "churn",
            label : "Churn",
            prefix: "$",
            value : data.widgets.churn
        }
    ];

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Retention",
                        active: true
                    }
                ]}
                rightChildren={
                    <Flex align="center">
                        <DateRangePicker
                            control={control}
                            customOnChange={handleDateChange}
                            maxDate={new Date()}
                            id="date"
                            name="date"/>
                    </Flex>
                }/>
            <LoaderOverlay
                active={loading}
                children={
                    <Card>
                        <h3 className="font-medium-4">{t("Retention Rate")}</h3>
                        <Flex className="w-100 px-3 mt-1" justify="between" align="center">
                            {widgetSections.map(
                                ({ id, label, value, prefix, suffix, nextOperator }) => (
                                    <Fragment key={id}>
                                        <Flex className="mt-1" column align="center">
                                            <StatsFormatter
                                                className="font-large-1 fw-bolder"
                                                id={id}
                                                prefix={prefix}
                                                suffix={suffix}
                                                num={value}/>
                                            <p>{t(label)}</p>
                                        </Flex>
                                        {nextOperator && <h1>{nextOperator}</h1>}
                                    </Fragment>
                                )
                            )}
                        </Flex>

                        <Charts
                            type="column"
                            series={data.chart.series}
                            categories={data.chart.categories}
                            options={data.chart.chartOptions}
                            height={400}
                            plotOptions={{
                                column: {
                                    stacking  : "normal",
                                    dataLabels: {
                                        enabled: false
                                    }
                                }
                            }}/>
                    </Card>
                }/>
        </>
    );
};

export default RetentionReport;
